// /fisUsers 권한 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 직원 권한(auth)
export const authMeta: Record<string, StatusMeta> = {
  ADMIN: { label: "어드민", color: "error" },
  MANAGER: { label: "관리자", color: "primary" },
  USER: { label: "콜요원", color: "info" },
  AGENT: { label: "현장요원", color: "success" },
  FIRED: { label: "퇴사", color: "default" },
};

// 매핑에 없는 값도 안전하게 표시 (기존 동작: 알 수 없는 값은 그대로 출력)
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
